import md5 from "js-md5";
import request from "axios";
import constant from "@/utils/constant";


var qs = require("qs");
var API = constant.API_URL + "/auth";


export function token(form) {

  let pwd;
  if (form.platform == "talkie") {
    pwd = md5(form.password);
  } else {
    pwd = md5(md5(form.password));
  }
  let temp =form.account

  const data = {
    account: form.account.toLowerCase(),
    password: pwd,
    domain: form.domain,
    platform: form.platform
  };

  return request({
    url: API + "/token",
    method: "post",
    data: data
  });
}


export function oneClickLogin(form) {
  const data = {
    account: form.account,
    password: form.password,
    domain: form.domain,
    platform: form.platform
  };

  return request({
    url: API + "/token",
    method: "post",
    data: data
  });
}


export function getUserInfo() {
  return request({
    url: API + "/getUserInfo",
    method: "get",
  });
}












// WEBPACK FOOTER //
// ./src/store/modules/api/auth.js